<template>
    <div class="entity-form" @click="(e)=>{e.stopPropagation()}">
        <form @submit.prevent="(e)=>{e.stopPropagation()}">
            <div class="form-heading">
                <div class="form-title">{{$t('form.merge.title')}}</div>
                <button class="button-primary button-primary__thin"
                  :aria-disabled="hostPerson === -1 || $store.state.customers.merge.merging" :disabled="hostPerson === -1 || $store.state.customers.merge.merging"
                  @click="cancelForm"
                >
                    {{$t('form.merge.cancel')}}
                </button>
            </div>

            <div style="margin-top: 15vh;text-align: center;" v-if="!showCustomerList">
              <Spinner/>
            </div>

            <template v-else>
              
              <div class="flex-column" v-if="!$store.state.customers.merge.target">
                  <div class="customers-bar" :class="{loaded: showCustomerList}">
                      <div class="filter" style="padding-bottom: 16px;">
                           <FormFilter ref="filter"
                              :placeholder="$t('form.merge.search_placeholder')"
                              @update-search-string="searchStringUpdated"
                              @update="customersUpdated"
                            />
                      </div>

                      <div class="list" style="max-height: calc(100vh - 200px); overflow-y: scroll;">
                        <div v-if="orderby" class="custlist-ungrouped" :class="orderby">
                          <CustomerListElement v-for="cust in customers" :key="cust.id"
                              mode="list"
                              :filtered="filtered"
                              :customer="cust"
                              @click="selectCustomerToMerge(cust.id)"
                              show-sales-volume
                          />
                        </div>
                        
                        <template v-else-if="customers.size">
                          <div v-for="(custlist, index) in customers" :key="index">
                              <div class="cust-list-alpha-heading">{{custlist[0]}}</div>
                              <CustomerList mode="list" 
                                  :customers="custlist[1]" :filtered="filtered" :party="party"
                                  @customer-element-clicked="selectCustomerToMerge"
                              />
                          </div>
                        </template>
                        <div v-else class="no-results">
                          <div class="subheading-filtered">{{$t('widget.customers.subHeadingFilteredNoResults')}}</div>
                          <AddButton @click="openAddNewCustomer" class="add-participant-button" wide :color="'green'" :text="$t('widget.customers.addNewCustButton')" />
                        </div>
                      </div>

                  </div>
              </div>

              <div class="flex-column" v-else>
                <MergeCustomer @merged="mergeSuccess"/>
              </div>

            </template>

        </form>
    </div>
</template>

<script>
import * as types from '@/store/mutations'
import { nextTick } from 'vue'
import Spinner from "@/components/core/Spinner.vue";
import CustomerList from '@/components/lists/CustomerList.vue'
import FormFilter from '@/components/forms/filter/FormFilter.vue'
import AddButton from "@/components/core/AddButton.vue";
import CustomerListElement from "@/components/lists/elements/CustomerListElement.vue";
import MergeCustomer from "@/components/forms/merge/MergeCustomer.vue";

export default {
  name: 'ParticipantForm',
  components: {
    CustomerList,
    FormFilter,
    AddButton,
    Spinner,
    CustomerListElement,
    MergeCustomer
  },
  data () {
    return {
      filtered: '',
      customers: new Map(),
      partyId: -1,
      party: null,
      customersLoaded: false,
      hostPerson: 1, // TODO: this was undefined, adding here to fix console warnings
      orderby: null
    }
  },
  props: {
    reference: {
      type: [Number, String],
      default: -1
    }
  },
  emits:['add-component-clicked', 'form-closed'],
  computed: {
    showCustomerList(){
      return this.customersLoaded
    },
  },
  mounted () {
    if (this.reference > 0) {
      this.partyId = this.reference
    }
    this.$store.dispatch('loadAllCustomers').then(() => {
      this.$store.dispatch('loadParty', this.reference).then((res) => {
        this.party = res[0]
      }).catch(err => {
        console.error('ParticipantForm.mounted fail ->', err)
      }).finally(() => {
        // to split up 1 big freeze to two mediums
        setTimeout(() => { this.customersLoaded = true }, 150)
        // TODO: debug: why does it freeze like this?
      })
    })
  },

  methods: {
    mergeSuccess(targetId){
      this.$store.commit(types.CLOSE_MERGEFORM)
      this.$router.replace({name: "Customer", params: {id: targetId} })
    },
    customersUpdated(customers){
      nextTick(()=>{
        this.orderby = this.$refs['filter'].orderby
        this.customers = customers
       })
    },
    searchStringUpdated(str){ 
      this.filtered = str
    },
    openAddNewCustomer(){
      let prefilledName = this.filtered
      this.$store.commit(types.SET_CREATECUSTOMER_PREFILL, prefilledName)
      this.addEntity()
    },
    addEntity(){
        this.$emit('add-component-clicked', 'customer')
    },
    cancelForm () {
      this.$store.commit(types.CLOSE_MERGEFORM)
      this.$emit('form-closed')
    },
    partyHasParticipant(party, customerId){
        let participants = party?.customerOrders
        if(!customerId || !participants?.length){
            return false
        }

        let found = false
        for(const customer of participants){
            if(customerId == customer.customer.id){
                found = true
                break
            }
        }

        return found
    },
    selectCustomerToMerge (custId) {
      console.log("merge:",custId);
      this.$store.commit(types.MERGE_PICKTARGET, custId)
    }
  }
}
</script>
